import React, { useContext } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Tooltip,
} from "@material-ui/core";

import Tabs from "../../../../components/tabs/TabsErp";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal } from "../styles/Emissao";

import TabInutilizar from "./TabInutilizarNfe";
import TabHistoricoInutilizacao from "./TabHistoricoInutilizacaoNfe";
import useNfeController from "../controllers/NfeController";
import { PainelNfeContext } from "../contexts/PainelNfeContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const tabHeaders = [
  {
    label: "Inutilizar",
  },
  {
    label: "Histórico",
  },
];

const ModalInutilizarNfe = ({
  openModal,
  setOpenModal,
  selectedNotes,
  setMainLoading,
}) => {
  const { handleInutilizarNumNfe, clearInutilizacaoNfe, handleGetDataTable } =
    useNfeController();

  const handleClose = () => {
    clearInutilizacaoNfe();
    handleGetDataTable();
    setOpenModal(false);
  };

  const { justify, tabIndexUnunsed, setTabIndexUnunsed } =
    useContext(PainelNfeContext);

  const { queryParams } = useContext(QueryParamsContext);

  const tabContents = [
    <TabInutilizar key="tab-inutilizar" />,
    <TabHistoricoInutilizacao key="tab-historico-inutilizacao" />,
  ];

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={openModal}
      onClose={handleClose}
      aria-labelledby="dialog-inutilizar-nfe"
    >
      <HeaderModal>
        <DialogTitle id="dialog-inutilizar-nfe">
          <Chip
            label="Inutilização de Numeração da NF-e"
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Tabs
          headers={tabHeaders}
          children={tabContents}
          tabIndex={tabIndexUnunsed}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndexUnunsed(value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Tooltip
          title={
            queryParams.empresa_cnpj?.endsWith("_democ")
              ? "Operação não permitida em ambiente de treinamento"
              : ""
          }
          placement="top"
        >
          <span>
            <Btn
              label="Inutilizar"
              disabled={
                queryParams.empresa_cnpj?.endsWith("_democ") ||
                tabIndexUnunsed === 1 ||
                justify.length < 15
              }
              onClick={() => {
                handleInutilizarNumNfe(
                  selectedNotes.filter((note) => note.status === "D"),
                  setMainLoading
                );
              }}
            />
          </span>
        </Tooltip>
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalInutilizarNfe;
